import { inject } from '@angular/core';
import { AppStateService, GoogleAnalyticsService, HttpErrorService, MembershipsCheckoutService, MembershipsService } from '../../../services';
import { distinctUntilChanged } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CheckoutTotals, ProcessOrderResponse } from '../../../models';
import { GAEventAction, PaymentStatus, PaymentType, PublicRoutes } from '../../../enums';
import { MessageService } from 'primeng/api';
import { NavigationExtras, Router } from '@angular/router';

/** when extending this class be sure to implement ngOnInit */
export abstract class NgxAimMembershipOverviewClass {
  //   ngOnInit {
  //   this.init();
  // }

  checkoutService = inject(MembershipsCheckoutService);
  httpErrorService = inject(HttpErrorService);
  appState = inject(AppStateService);
  messageService = inject(MessageService);
  router = inject(Router);
  gaService = inject(GoogleAnalyticsService);
  membershipsService = inject(MembershipsService);

  membership = this.membershipsService.selectedMembership;
  routes = PublicRoutes;

  totals$ = this.checkoutService.totals$.pipe(
    distinctUntilChanged(),
    takeUntilDestroyed(),
  );
  totals: CheckoutTotals = {
    items: 0,
    shipping: 0,
    tax: 0,
    total: 0,
  }
  isProcessing = false;
  showError = false;

  init() {
    this.totals$.subscribe(totals => {
      this.totals = totals;
    });
  }

  onCompleteClick() {
    if (this.appState.paymentType === PaymentType.NONE && this.totals.total !== 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Failed',
        detail: 'Cannot not check out at this time. No payment processor',
        key: 'app-toast'
      });
      return;
    }

    this.isProcessing = true;

    this.checkoutService.checkout().subscribe({
      next: (res) => this.handleCheckoutResponse(res),
      error: (err) => this.onError(err),
    });
  }

  handleCheckoutResponse(res: ProcessOrderResponse) {
    this.isProcessing = false;
    if (res.paymentStatus === PaymentStatus.APPROVED) {
      this.emitGaEvent(res);
      this.checkoutService.reset();

      const navigationExtras: NavigationExtras = {
        state: {
          orderId: res.orderId,
        },
      }
      this.router.navigate([PublicRoutes.MEMBERSHIPS, PublicRoutes.MEMBERSHIP_COMPLETE], navigationExtras);
    } else {
      this.showError = true;
    }
  }

  emitGaEvent(res: ProcessOrderResponse) {
    const membership = this.membershipsService.selectedMembership!;
    this.gaService.emitEvent(GAEventAction.PURCHASE, {
      transaction_id: res.orderId,
      currency: 'USD',
      value: this.totals.items,
      tax: this.totals.tax,
      shipping: this.totals.shipping,
      items: [{
        item_id: membership.MbsPk,
        item_name: membership.Description,
        price: this.totals.items,
        quantity: 1,
      }],
    });
  }

  onError(err: any) {
    this.isProcessing = false;
    this.httpErrorService.onHttpError(err, `We couldn't process your order`);
  }
}
